<template>
    <v-layout class="mx-0" row wrap>
        <v-flex md12>
            <v-checkbox
                    :label="$vuetify.lang.t('$vuetify.have_extra_passport')"
                    outlined
                    v-model="extraPassport"
            >/
            </v-checkbox>
        </v-flex>

        <v-layout class="mx-0" md12 row v-if="extraPassport" wrap>
            <v-flex class="pr-2" md4 sm12>
                <v-autocomplete
                        :class="{'pr-0': $vuetify.breakpoint.smAndDown, 'pr-3': $vuetify.breakpoint.mdAndUp}"
                        :clearable="true"
                        :items="countries"
                        :label="$vuetify.lang.t('$vuetify.select_country')+' *'"
                        :rules="[rules.required]"
                        item-text="country_name"
                        item-value="id"
                        outlined
                        v-model="visa.extra_passport_country"
                />
            </v-flex>
            <v-flex md4 sm12>
                <v-text-field
                        :class="{'pr-0': $vuetify.breakpoint.smAndDown, 'pr-3': $vuetify.breakpoint.mdAndUp}"
                        :clearable="true"
                        :label="$vuetify.lang.t('$vuetify.passport_number')+' *'"
                        :rules="[rules.required]"
                        outlined
                        v-model="visa.extra_passport_no"
                />
            </v-flex>
            <v-flex  md4
                    sm12
                    :class="{'pl-0': $vuetify.breakpoint.smAndDown, 'pl-3': $vuetify.breakpoint.mdAndUp}"
            >
                <date-picker-new :for-passport="1"
                                 :label="$vuetify.lang.t('$vuetify.passport_day')"
                                 v-model="visa.extra_passport_validity"
                />

            </v-flex>
            <v-flex md4 sm12
                    :class="{'pr-0': $vuetify.breakpoint.smAndDown, 'pr-3': $vuetify.breakpoint.mdAndUp}">
                <file-input

                        :required="true"
                        label="Passport Scanned Copy. *"
                        v-model="visa.extra_passport_image"
                />
            </v-flex>
        </v-layout>
    </v-layout>
</template>

<script>
    import {validationMixin} from "../../mixins/validationMixin";
    import {mapGetters} from 'vuex';
    import FileInput from "../FileInput";
    import DatePickerNew from "../../components/DatePickerNew";


    export default {
        name: "ExtraPassportDetail",
        components: {FileInput,DatePickerNew},
        props: {
            visa_prop: {
                type: [Array, Object]
            },
        },
        data() {
            return {
                extraPassport: false,
                visa: [],
            }
        },
        mixins: [validationMixin],
        computed: {
            ...mapGetters({
                countries: 'CountryForTouristList/all',
            }),
        },
        mounted() {
            this.visa = this.visa_prop;
        }
    }
</script>

<style scoped>

</style>
